
import { NavLink, useParams } from "react-router";

import { useTraductionsByIdQuery } from "../../stores/OkOkStore";
import TraductionsEditForm from "../../components/Traductions/TraductionsEditForm";
import { useTrads } from "../../contexts/trads/useTrads";

function TraductionsEdit(){
    const params = useParams();
    const {translate}=useTrads();
    const { data:traduction, error, isLoading } = useTraductionsByIdQuery(params.id??"0");

    return (

        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : traduction ? (
            <div>
                <nav>
                    <ul className="nav nav-tabs">
                        <li className="nav-item"><NavLink className="nav-link" to={`/traductions/${traduction.id.toString()}/edit`}>{translate('btn_edit')}</NavLink></li>
                    </ul>
                </nav>

                <TraductionsEditForm  traductionParam={traduction} ></TraductionsEditForm>

            </div>

        ):null
    );
}
export default TraductionsEdit;